package com.ilussobsa.views

import com.ilussobsa.Auctioneer
import com.ilussobsa.Resources
import com.ilussobsa.utils.AuctioneerPack
import com.ilussobsa.utils.audioPack
import com.lightningkite.kiteui.Routable
import com.lightningkite.kiteui.SoundEffectPool
import com.lightningkite.kiteui.backgroundAudio
import com.lightningkite.kiteui.load
import com.lightningkite.kiteui.models.AudioResource
import com.lightningkite.kiteui.navigation.Page
import com.lightningkite.kiteui.navigation.pageNavigator
import com.lightningkite.kiteui.views.*
import com.lightningkite.kiteui.views.direct.*
import com.lightningkite.kiteui.views.l2.*
import com.lightningkite.reactive.context.invoke
import com.lightningkite.reactive.core.Signal

@Routable("audio-test")
class AudioTestScreen: Page {
    val usePool = Signal(true)
    override fun ViewWriter.render(): ViewModifiable {
        val pool = SoundEffectPool()
        return scrolling - col {
            backgroundAudio(Resources.auctioneerCrowdBackground, 0.4f) { true }
            row {
                checkbox { checked bind usePool }
                text("Use pool")
            }
            Auctioneer.Recording1.audioPack().run {
                listOf(
                    "auctionEnd" to auctionEnd,
                    "goingOnce" to goingOnce,
                    "goingTwice" to goingTwice,
                    "next" to next,
                    "priceDrop" to priceDrop,
                    "bottomPrice" to bottomPrice,
                    "reserveMet" to reserveMet,
                    "sold" to sold,
                    "offerReady" to offerReady,
                    "noSale" to noSale,
                    "welcome" to welcome,
                    "bidPlaced" to bidPlaced,
                    "firstBidPlaced" to firstBidPlaced,
                ).flatMap { it.second.audio.map { a -> it.first to a } }
                    .plus(pokes.map { it.text to it.audio })
            }.forEach { (name: String, it: AudioResource) ->
                button {
                    text(name)
                    onClick {
                        if(usePool()) {
                            pool.play(it)
                        } else {
                            it.load().play()
                        }
                    }
                }
            }
        }
    }
}